// extracted by mini-css-extract-plugin
export default {"subtitle":"src-components-atoms-sub-title-sub-title-module__subtitle--edae9"};